export default {
  status: {
    processing: false,
    error: null,
    success: null,
    previous: null
  },
  notification: {},
  notifications: [],
  notificationContract: {},
  notificationContracts: [],
  notificationCurriculumExternal: {},
  notificationCurriculumExternals: [],
  notificationCall: {},
  notificationsCall: [],
  notificationContractsCall: [],
  notificationCallEx: {},
  notificationsCallEx: [],
  notificationContractsCallEx: [],
  notificationSale: {},
  notificationsSale: [],
  notificationContractSale: {},
  notificationContractsSale: [],
  notificationLawyer: {},
  notificationsLawyer: [],
  notificationStudentApp: {},
  notificationsStudentApp: [],
}
